<template>
    <div class="list_nav_wrap toggle-nav nav-model">
        <h1 class="list_nav_title">
            <label>{{ keyName }}</label>
        </h1>
        <ul class="clearfix">
            <li v-for="item in listCarModel">
                <a :class="{
                        'listNav_active': activeCarModel === item.value
                    }"
                    @click="doSelectCarModel(item.value)">
                    <div class="car-modal-img "
                        :class="'modal-' + item.iconName"></div>
                    <span class="car-modal-name">{{ item.name }}</span>
                </a>
            </li>
            <li v-for="item in listBodyModels">
                <a :class="{
                        'listNav_active': ~~activeBodyModels === item.value
                    }"
                    @click="doSelectBodyModels(item.value)">
                    <div class="car-modal-img "
                        :class="'modal-' + item.iconName"></div>
                    <span class="car-modal-name">{{ item.name }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    // let formBean = window._qiwa.page_global.formBean;
    export default {
        data() {
            return {
                keyName: '车型',
                activeCarModel: locationObj.search.get('carModel'),
                activeBodyModels: locationObj.search.get('bodyModels'),
                listCarModel: [{
                    value: 'SUV',
                    name: 'SUV',
                    iconName: 'suv'
                }, {
                    value: 'MPV',
                    name: 'MPV',
                    iconName: 'mpv'
                }, {
                    value: 'tinyCar',
                    name: '微小型车',
                    iconName: 'tinycar'
                }, {
                    value: 'compactCar',
                    name: '紧凑型车',
                    iconName: 'compactcar'
                }, {
                    value: 'midSize',
                    name: '中型车',
                    iconName: 'midsize'
                }, {
                    value: 'PremiumMidsize',
                    name: '中大型车',
                    iconName: 'premiummidsize'
                }, {
                    value: 'SportsCar',
                    name: '跑车',
                    iconName: 'sportcar'
                }],
                listBodyModels: [{
                    value: 5,
                    name: '两厢车',
                    iconName: 'doublebox'
                }, {
                    value: 6,
                    name: '三厢车',
                    iconName: 'sedan'
                }]
            };
        },
        methods: {
            doSelectCarModel(value) {
                if (value) {
                    locationObj.s('carModel', value).s('index', null).go();
                } else {
                    locationObj.s('carModel', null).s('index', null).go();
                }
            },
            doSelectBodyModels(value) {
                if (value) {
                    locationObj.s('bodyModels', value).s('index', null).go();
                } else {
                    locationObj.s('bodyModels', null).s('index', null).go();
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavType.vue?18b0c88c